import React, { SyntheticEvent } from 'react';
import { useStyles } from './DepartmentSelector.styles';
import { Autocomplete, AutocompleteRenderInputParams, FilterOptionsState, TextField } from '@mui/material';
import { Field } from 'formik';
import { DepartmentData } from '@shared/interfaces/DepartmentData';

interface Props {
  name: string;
  label?: string;
  placeholder?: string;
  options: DepartmentData[];
  value: string[];
  onChange: (fieldName: string, newValue: string[]) => void;
  identifier?: keyof DepartmentData;
}

export const DepartmentSelector: React.FC<Props> = ({
  name,
  label = 'Department and project',
  placeholder,
  options,
  value,
  onChange,
  identifier = 'name',
}) => {
  const styles = useStyles();

  const selectedOptions = options.filter((option) => value.includes(option[identifier]));

  return (
    <Field
      name={name}
      component={Autocomplete}
      className={styles.selectorInput}
      multiple
      filterOptions={(x: DepartmentData[], state: FilterOptionsState<DepartmentData>) =>
        x.filter((option) => option.name.toLowerCase().includes(state.inputValue.toLowerCase()))
      }
      getOptionLabel={(option: DepartmentData) => option.name}
      noOptionsText="No such project"
      options={options}
      value={selectedOptions}
      onChange={(_: SyntheticEvent, newValue: DepartmentData[]) =>
        onChange(
          name,
          newValue.map((v) => v[identifier])
        )
      }
      renderInput={(params: AutocompleteRenderInputParams) => (
        <TextField
          {...params}
          fullWidth
          label={label}
          placeholder={value.length === 0 ? placeholder || 'All projects' : undefined}
          className={styles.textField}
        />
      )}
    />
  );
};
